import VueLogger from 'vuejs3-logger'
import { env } from '@shared/config/env'

const logLevel = env.logLevel || 'error'

export default {
  install: (app) => {
    const options = {
      isEnabled: true,
      logLevel: logLevel,
      stringifyArguments: false,
      showLogLevel: true,
      showMethodName: true,
      separator: '|',
      showConsoleColors: true
    }

    app.use(VueLogger, options)
  }
}
